import { LazyPage } from '../components/loadable';

// import DanhGiaDinhKyLayout from './pages/danh-gia/dinh-ky';
// import DanhGiaThuongXuyenLayout from './pages/danh-gia/thuong-xuyen';

export { default as HomePage } from './home/home';
export * from './danh-muc'
export * from './sync-moet-hcm'
export * from './account'
export const LopBoMonPage = LazyPage(import('./lop-bo-mon'))
export const LopMonHocPage = LazyPage(import('./lop-mon-hoc'))
export const ConfigSoDiemTieuHocPage = LazyPage(import('./so-diem-tieu-hoc'))
export const SoDiemPage = LazyPage(import('./so-diem-trung-hoc'))
export const GanSoDiemLayout = LazyPage(import('./gan-so-diem-layout'))
export const SoDiemLayout = LazyPage(import('./so-diem-layout'))

export const AppMenuPage = LazyPage(import('./app-phuhuynh/app-menu'));
export const AppMenuTruongConfig = LazyPage(import('./app-phuhuynh/app-menu-truong'));
export const AppAccountPage = LazyPage(import('./app-phuhuynh/app-account'));
export const AppMenuListConfig = LazyPage(import('./app-phuhuynh/app-menu/list-config'));
export const BaiVietPage = LazyPage(import('./bai-viet'));
export const BaiVietChoDuyetPage = LazyPage(import('./bai-viet/bai-viet-cho-duyet'));
export const BaiVietDetailPage = LazyPage(import('./bai-viet/bai-viet-detail'));
export const AppXinNghiPage = LazyPage(import('./app-xinnghi'));
export const AppXinNghiDetailPage = LazyPage(import('./app-xinnghi/detail-page'));
export const DiemDanhPage = LazyPage(import('./diem-danh'));
export const NhanXetHangNgayPage = LazyPage(import('./nhan-xet-hang-ngay'));
export const NhanXetHangNgayCommentPage = LazyPage(import('./nhan-xet-hang-ngay/comment'));
export const BaiTapPage = LazyPage(import('./bai-tap'));
export const NhapDiemPage = LazyPage(import('./nhap-diem'));
export const LopHanhChinhPage = LazyPage(import('./lop-hanh-chinh'));
export const GanSoDiemPage = LazyPage(import('./gan-so-diem'));
export const ThongTuPage = LazyPage(import('./thong-tu'));
export const DanhMucTuanTietPage = LazyPage(import('./danh-muc'));
export const DiemVanMinhKetQuaPage = LazyPage(import('./diemvanminh/diemvanminh-ketqua'));
export const DiemVanMinhTieuChiPage = LazyPage(import('./diemvanminh/diemvanminh-tieuchi'));
export const TongHopDinhKyPage = LazyPage(import('./tong-hop-dinh-ky'));

export const GanSoNLPCPage = LazyPage(import('./gan-so-nlpc'));
export const DGDKNLPCPage = LazyPage(import('./danh-gia/dinh-ky/nlpc'));
export const ThoiKhoaBieuPreviewPage = LazyPage(import('./thoi-khoa-bieu/thoi-khoa-bieu-preview'));
export const ThoiKhoaBieuConfigPage = LazyPage(import('./thoi-khoa-bieu/thoi-khoa-bieu-config'));
export const ThoiKhoaBieuPreviewGiaoVienPage = LazyPage(import('./thoi-khoa-bieu/thoi-khoa-bieu-giaovien'));
// export const ThoiKhoaBieuImport = LazyPage(import('./thoi-khoa-bieu/thoi-khoa-bieu-import'));
export const BaoCaoTienBoPage = LazyPage(import('./bao-cao-tien-bo'));
export const ExcelTemplateAuthoringPage = LazyPage(import('./excel-template-authoring'));
export const ReportTemplateMasterPage = LazyPage(import('./report-template-master'));
export const XepHangHocSinhPage = LazyPage(import('./xep-hang-hoc-sinh'));
export const LopMonHocLayout = LazyPage(import('./lop-mon-hoc-layout'));

export const DanhGiaDinhKyLayout = LazyPage(import('./danh-gia/dinh-ky'));
export const DanhGiaThuongXuyenLayout = LazyPage(import('./danh-gia/thuong-xuyen'));
export const KhoaDanhGiaPage = LazyPage(import('./danh-gia/khoa-danh-gia'));
export const BaoCaoDiemDanhPage = LazyPage(import('./bao-cao-diem-danh'));
export const BaoCaoDiemDanhTietHocPage = LazyPage(import('./bao-cao-diem-danh-tiet-hoc'));
export const LichSuNhapDiemPage = LazyPage(import('./lich-su-nhap-diem'));
export const TienDoNhapDiemPage = LazyPage(import('./tien-do-nhap-diem'));
export const HocSinhProfilePage = LazyPage(import('./hoc-sinh'));
export const BaoCaoNhanXetHangNgayTrungBinhPage = LazyPage(import('./bao-cao-nhan-xet-hang-ngay-tb'))
export const DangKyMonHocPage = LazyPage(import('./dangky-monhoc'));
export const KetQuaDangKyMonHoc = LazyPage(import('./dangky-monhoc-ketqua'));
export const ChamTietCaNhanPage = LazyPage(import('./cham-tiet/cham-tiet-ca-nhan'));
export const DuyetChamTietPage = LazyPage(import('./cham-tiet/duyet-cham-tiet'));
export const QuanLyChamTietPage = LazyPage(import('./cham-tiet/quan-ly-cham-tiet'));
export const PhanCongGiangDayPage = LazyPage(import('./phan-cong-giang-day'));

export const FormKhaoSatPage = LazyPage(import('./form-khaosat'));
export const KhaoSatPage = LazyPage(import('./khao-sat'));
export const KhaoSatResultPage = LazyPage(import('./khao-sat-result'));
export const PhoDiemPage = LazyPage(import('./pho-diem'));
export const DiemDanhAnPage = LazyPage(import('./diem-danh-an'));
export const MeetingPage = LazyPage(import('./meeting'));
export const MeetingDetail = LazyPage(import('./meeting-detail'));
export const BaoCaoDiemDanhAnPage = LazyPage(import('./bao-cao-diem-danh-an'));

// ===== Module Bus (quản lý xe buýt) =====
export const BusXePage = LazyPage(import('./bus/xe'));
export const BusNhaXePage = LazyPage(import('./bus/nha-xe'));
export const BusLaiXePage = LazyPage(import('./bus/lai-xe'));
export const BusMonitoringPage = LazyPage(import('./bus/monitoring'));
export const CauHinhXeBusPage = LazyPage(import('./bus/cau-hinh-xe-bus'));
export const BusBangKiemTuanThuPage = LazyPage(import('./bus/bang-kiem-tuan-thu'));
export const BusDiemDonTraPage = LazyPage(import('./bus/diem-don-tra'));
export const BusDiemDanhBaoCaoPage = LazyPage(import('./bus/bao-cao-diem-danh'));
export const BusTuyenDuongPage = LazyPage(import('./bus/tuyen-duong'));
export const BusDangKyXePage = LazyPage(import('./bus/dang-ky-xe'));
export const PhanTuyenPage = LazyPage(import('./bus/phan-tuyen'));

// ===== Module Dịch vụ =====
export const CauHinhLoaiDichVuPage = LazyPage(import('./dich-vu/cau-hinh-loai-dich-vu'));
export const SaleSetRegisterPage = LazyPage(import('./dich-vu/saleset-register'));
export const SaleSetRegisterDichVuPage = LazyPage(import('./dich-vu/saleset-register-dich-vu'));
export const FoMonAnChiTietPage = LazyPage(import('./dich-vu/food/mon-an-chi-tiet'));
export const FoCaAnTruongPage = LazyPage(import('./dich-vu/food/ca-an-truong'));
export const FoThucDonPage = LazyPage(import('./dich-vu/food/thuc-don'));

// ===== Module Y Tế =====
export const UnitPage = LazyPage(import('./y-te/unit'));
export const MedicationPage = LazyPage(import('./y-te/medication'));
export const HealthProblemPage = LazyPage(import('./y-te/health-problem'));
export const StudentMedicalHistoryPage = LazyPage(import('./y-te/student-medical-history'));
export const StudentMedicalHistoryDetailPage = LazyPage(import('./y-te/student-medical-history-detail'));
export const StudentLogPage = LazyPage(import('./y-te/student-log'));
export const DanThuocPage = LazyPage(import('./y-te/dan-thuoc'));
